export function collectRefs(doc) {
    const productIds = new Set();
    const collectionIds = new Set();
    const scan = (settings) => {
        for (const v of Object.values(settings)) {
            if (v && typeof v === 'object' && 'kind' in v) {
                if (v.kind === 'product')
                    productIds.add(v.id);
                else if (v.kind === 'collection')
                    collectionIds.add(v.id);
            }
        }
    };
    // Blocks nest (a container block owns child blocks), so recurse — a picker on a CHILD block references a
    // real product exactly like one on a top-level block. Mirrors the backend's depth-agnostic ref scan.
    const scanBlocks = (blocks) => {
        for (const b of blocks ?? []) {
            scan(b.settings);
            scanBlocks(b.blocks);
        }
    };
    for (const s of doc.sections) {
        scan(s.settings);
        scanBlocks(s.blocks);
    }
    return { productIds: [...productIds], collectionIds: [...collectionIds] };
}
/**
 * The collection ids that also need their MEMBER PRODUCTS loaded — the `featured-collection` grid, the only
 * section that paints a collection's products rather than the collection itself.
 *
 * Mirrors the backend's own walk (`StorefrontPageQueryService.collectFeaturedCollectionIds`) so the editor
 * asks for exactly what the page bundle resolves: the section's own `collection` setting (single mode) and
 * the `collection` of each `tab` block it owns (category-tabs mode). Deliberately NOT every collection ref in
 * the document — a `collection-list` shows collection CARDS and needs no product load, and resolving one per
 * card would turn a twelve-collection page into twelve extra requests.
 */
export function collectFeaturedCollectionIds(doc) {
    const ids = new Set();
    const add = (settings) => {
        const v = settings?.collection;
        if (v && typeof v === 'object' && 'kind' in v && v.kind === 'collection')
            ids.add(v.id);
    };
    for (const s of doc.sections) {
        if (s.type !== FEATURED_COLLECTION_TYPE)
            continue;
        add(s.settings);
        for (const b of s.blocks ?? []) {
            if (b.type === FEATURED_COLLECTION_TAB_TYPE)
                add(b.settings);
        }
    }
    return [...ids];
}
/** The one section type whose picked collection needs a product grid. */
const FEATURED_COLLECTION_TYPE = 'featured-collection';
/** Its block type in category-tabs mode — one per tab, each pointing at its own collection. */
const FEATURED_COLLECTION_TAB_TYPE = 'tab';
//# sourceMappingURL=refs.js.map